"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultRole = exports.useAllowedRoles = exports.useJWT = exports.useHasuraClaims = exports.useRegister = exports.useLogout = exports.useLogin = exports.useStatus = void 0;
const vue_demi_1 = require("vue-demi");
const inject_key_1 = require("./inject-key");
const injectInstance = () => {
    const instance = vue_demi_1.inject(inject_key_1.DefaultHasuraBackendPlusKey);
    if (!instance)
        throw Error('No HBP instance');
    return instance;
};
const useStatus = () => injectInstance().authenticated;
exports.useStatus = useStatus;
const useLogin = (email, password) => {
    const { auth } = injectInstance();
    const error = vue_demi_1.ref();
    const data = vue_demi_1.ref();
    return {
        login: () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                error.value = undefined;
                data.value = yield auth.login(email.value, password.value);
            }
            catch (err) {
                error.value = err;
            }
        }),
        data,
        error
    };
};
exports.useLogin = useLogin;
const useLogout = (allDevices) => {
    const { auth } = injectInstance();
    return () => auth.logout(allDevices === null || allDevices === void 0 ? void 0 : allDevices.value);
};
exports.useLogout = useLogout;
const useRegister = (email, password) => {
    const { auth } = injectInstance();
    const error = vue_demi_1.ref();
    return {
        register: () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                error.value = undefined;
                yield auth.register(email.value, password.value);
                yield auth.login(email.value, password.value);
            }
            catch (err) {
                error.value = err;
            }
        }),
        error
    };
};
exports.useRegister = useRegister;
const useHasuraClaims = () => injectInstance().claims;
exports.useHasuraClaims = useHasuraClaims;
const useJWT = () => {
    const instance = injectInstance();
    return vue_demi_1.computed(() => instance.token.value);
};
exports.useJWT = useJWT;
const useAllowedRoles = (excludeRole = []) => {
    const instance = injectInstance();
    const exclude = Array.isArray(excludeRole) ? excludeRole : [excludeRole];
    return vue_demi_1.computed(() => {
        var _a;
        return (((_a = instance.claims.value) === null || _a === void 0 ? void 0 : _a['x-hasura-allowed-roles']) || []).filter(role => !exclude.includes(role));
    });
};
exports.useAllowedRoles = useAllowedRoles;
const useDefaultRole = () => {
    const instance = injectInstance();
    return vue_demi_1.computed(() => { var _a; return (_a = instance.claims.value) === null || _a === void 0 ? void 0 : _a['x-hasura-default-role']; });
};
exports.useDefaultRole = useDefaultRole;
//# sourceMappingURL=composables.js.map